import React from 'react';

export const CurrentProjectIdContext = React.createContext<null | number>(null);

export const useCurrentProjectId = (): number => {
  const context = React.useContext(CurrentProjectIdContext);

  if (!context) {
    throw new Error(
      'projectId is missing. Please wrap the component with CurrentProjectIdContext.Provider',
    );
  }

  return context;
};
